exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plain_no_round_left[data-v-0b797088]{width:5px;height:9px;border-radius:0 5px 5px 0;background-color:#fff;float:left;margin-left:-1px;border:1px solid #ee0a24;border-left:0}.plain_no_round_right[data-v-0b797088]{width:5px;height:9px;border-radius:5px 0 0 5px;background-color:#fff;float:right;margin-right:-1px;border:1px solid #ee0a24;border-right:0}.no_plain_no_round_left[data-v-0b797088]{width:6px;height:9px;border-radius:0 5px 5px 0;background-color:#fff;float:left;margin-left:-1px}.no_plain_no_round_right[data-v-0b797088]{width:6px;height:9px;border-radius:5px 0 0 5px;background-color:#fff;float:right;margin-right:-1px}", ""]);

// exports
